<app-dialog
  *ngIf="isOpen"
  [title]="''"
  [hideCommitButton]="true"
  [hideCancelButton]="true"
  widthSize="large"
  [persistent]="true"
  (cancel)="close()"
>
  <!-- カスタムヘッダー（タイトル + ナビゲーションボタン） -->
  <div class="c-prosche-detail-modal__header">
    <h3 class="c-prosche-detail-modal__header-title">御見積書確認</h3>
    <div class="c-prosche-detail-modal__header-nav" *ngIf="selectedRows.length > 1 || detailItems.length > 1">
      <button class="c-btn c-btn--blue" [disabled]="!canGoPrevious" (click)="previous()">前へ</button>
      <span class="c-prosche-detail-modal__header-page">{{ currentPageInfo }}</span>
      <button class="c-btn c-btn--blue" [disabled]="!canGoNext" (click)="next()">次へ</button>
    </div>
  </div>
  <div class="c-prosche-detail-modal">
    <!-- 基本情報表示エリア（横並びでコンパクトに） -->
    <div class="c-prosche-detail-modal__info" *ngIf="currentDetailItem">
      <div class="c-prosche-detail-modal__info-row">
        <div class="c-prosche-detail-modal__info-item">
          <span class="c-prosche-detail-modal__info-label">契約企業：</span>
          <span class="c-prosche-detail-modal__info-value">{{ currentDetailItem.rowData.contractCompanyName }}</span>
        </div>
        <div class="c-prosche-detail-modal__info-item">
          <span class="c-prosche-detail-modal__info-label">契約者：</span>
          <span class="c-prosche-detail-modal__info-value">{{ currentDetailItem.rowData.purchaserName }}</span>
        </div>
        <div class="c-prosche-detail-modal__info-item">
          <span class="c-prosche-detail-modal__info-label">メールアドレス：</span>
          <span class="c-prosche-detail-modal__info-value">{{ currentDetailItem.rowData.mailAddress }}</span>
        </div>
      </div>
      <div
        class="c-prosche-detail-modal__info-row"
        *ngIf="currentDetailItem.rowData.sendMailDatetimeUi || currentDetailItem.rowData.approvalDatetimeUi"
      >
        <div class="c-prosche-detail-modal__info-item" *ngIf="currentDetailItem.rowData.sendMailDatetimeUi">
          <span class="c-prosche-detail-modal__info-label">メール送信日時：</span>
          <span class="c-prosche-detail-modal__info-value">{{ currentDetailItem.rowData.sendMailDatetimeUi }}</span>
        </div>
        <div class="c-prosche-detail-modal__info-item" *ngIf="currentDetailItem.rowData.approvalDatetimeUi">
          <span class="c-prosche-detail-modal__info-label">ユーザー承認日時：</span>
          <span class="c-prosche-detail-modal__info-value">{{ currentDetailItem.rowData.approvalDatetimeUi }}</span>
        </div>
      </div>
    </div>

    <!-- PDF表示エリア -->
    <div class="c-prosche-detail-modal__pdf">
      <div *ngIf="currentDetailItem?.loading" class="c-prosche-detail-modal__loading">
        <p>読み込み中...</p>
      </div>
      <div *ngIf="!currentDetailItem?.loading && currentDetailItem?.pdfUrl" class="c-prosche-detail-modal__iframe">
        <iframe [src]="currentDetailItem.pdfUrl"></iframe>
      </div>
      <div *ngIf="!currentDetailItem?.loading && !currentDetailItem?.pdfUrl" class="c-prosche-detail-modal__error">
        <p>明細PDFの読み込みに失敗しました</p>
      </div>
    </div>

    <!-- 閉じるボタン -->
    <div class="c-prosche-detail-modal__close">
      <button class="c-btn" (click)="close()">閉じる</button>
    </div>
  </div>
</app-dialog>
